module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-reveal-void"
  }, [_c('ModalReveal', [_c('button', {
    staticClass: "button danger",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Billed Records")]), _c('div', {
    staticClass: "header",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('h2', [_vm._v("Records  "), _c('strong', [_vm._v("INV" + _vm._s(_vm.invoice.internal_id) + "(" + _vm._s(_vm.invoice.id) + ")")])])]), _c('BilledRecords', {
    attrs: {
      "item": _vm.invoice
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-abe54ec4!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/InvoiceRevealRecords.vue
// module id = 2657
// module chunks = 1